import { h } from "@stencil/core";
import { ServiceDocument } from "../../api/publicApi/serviceReports/document";
import { ReportItem } from "./report-row";

function getGroupedDocuments(documents: ServiceDocument[]): Record<string, ServiceDocument[]> {
    return (
        documents?.reduce(
            (acc, doc) => {
                const key = doc.mission.assignmentType;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(doc);
                return acc;
            },
            {} as Record<string, ServiceDocument[]>
        ) || {}
    );
}

export interface GroupedReportsProps {
    t: (key: string, options?: Record<string, unknown>) => string;
    documents: ServiceDocument[] | null;
    filteredDocuments?: ServiceDocument[] | null;
    isOnMachinePage: boolean;
    machineNumber?: string;
    machineAlias?: string;
    machineName?: string;
    technicianName?: string;
}

export const GroupedReports = ({
    t,
    documents,
    filteredDocuments,
    isOnMachinePage,
    machineNumber,
    machineAlias,
    machineName,
    technicianName
}: GroupedReportsProps) => {
    if (!documents || !filteredDocuments) {
        return null;
    }
    if (documents.length === 0) {
        return <div class="ux-u-text-align--center ux-text-normal">{t("mf-service-calls:serviceReports.noReportsAvailable")}</div>;
    }
    if (filteredDocuments.length === 0) {
        return <div class="ux-u-text-align--center ux-text-normal">{t("mf-service-calls:serviceReports.noReportsFound")}</div>;
    }
    const groupedDocuments = getGroupedDocuments(filteredDocuments);
    if (!isOnMachinePage) {
        return (
            <div>
                {filteredDocuments.map((doc) => (
                    <div class="ux-info-box">
                        <ReportItem
                            t={t}
                            document={doc}
                            machineNumber={machineNumber}
                            machineAlias={machineAlias}
                            machineName={machineName}
                            technicianName={technicianName}
                        />
                    </div>
                ))}
            </div>
        );
    }

    const getLabel = (type: string) => {
        return t(`mf-service-calls:serviceReports.reportTypesPlural.${type}`);
    };

    return (
        <div>
            {Object.keys(groupedDocuments)
                .sort((a, b) => getLabel(a).localeCompare(getLabel(b)))
                .map((missionType, i) => {
                    const amount = groupedDocuments[missionType].length;
                    return (
                        <ux-accordion key={missionType} isExpanded={i === 0}>
                            <span slot="title" class="ux-text-title ux-text-title--light">
                                {getLabel(missionType)} ({amount})
                            </span>
                            <mf-service-reports-paginated-items
                                t={t}
                                items={groupedDocuments[missionType]}
                                isOnMachinePage
                            ></mf-service-reports-paginated-items>
                        </ux-accordion>
                    );
                })}
        </div>
    );
};
